import Card from '../ui/Card'
import Sparkline from '../ui/Sparkline'
import { featuresContent } from '../../data/landing-content'

export default function FeatureGrid() {
  return (
    <section id="features" className="mt-22">
      <div className="mb-11">
        <h2 className="text-[clamp(2rem,2.8vw+1rem,2.8rem)] tracking-[-0.03em] font-bold m-0 mb-4">
          {featuresContent.sectionTitle}
        </h2>
        <p className="text-ink-soft leading-relaxed max-w-[520px] m-0">
          {featuresContent.sectionDescription}
        </p>
      </div>

      <div className="grid md:grid-cols-2 gap-6">
        {featuresContent.cards.map((card, idx) => (
          <Card
            key={idx}
            variant={card.accent ? 'accent' : 'muted'}
            className="min-h-[220px]"
          >
            <h3 className="text-[1.15rem] font-semibold m-0 mb-2.5">
              {card.title}
            </h3>
            <p className={`leading-[1.55] m-0 ${card.accent ? 'text-[rgba(240,245,255,0.78)]' : 'text-ink-soft'}`}>
              {card.description}
            </p>
            {card.accent && <Sparkline />}
          </Card>
        ))}
      </div>
    </section>
  )
}
